import { saleOffersSlice } from './slice'

export const {
  resetSalesOfferState,

  // All Sale Offer State
  setAllSaleOffersGroupValue,
  resetAllSalesOfferState,

  // Sale Offers Group
  setSaleOffersGroupValue,
  resetSalesOfferGroupCreateState,

  // Filter Project
  resetFilterProjectOfferState,
  setSaleOfferFilterProjectValue,

  // Create Sale Offer
  setCreateSaleOfferValue,
  resetCreateSaleOfferState,

  // User Sale Offers List
  resetUserSaleOffersState,
  setUserSaleOffersValue,

  // Sale Offer Details
  resetSaleOfferDetailsState,
  setSaleOfferDetailsValue,

  // Accept Sale Offer
  setAcceptSaleOfferValue,
  resetAcceptSaleOfferState,

  // Reject Offer
  resetRejectSaleOfferState,
  setRejectSaleOfferValue,

  // Make Counter Offer
  setCounterSaleOfferValue,
  resetCounterSaleOfferState,

  // Ui Reducers
  updateSaleOfferStatusOnList,
  updateAdminSaleOfferStatusOnList,
  addNewSaleOffer
} = saleOffersSlice.actions
